import type { ModelData } from '../../types'

export const dragonProsteAku: { [key: string]: ModelData } = {
  'dragon-aku-2': {
    id: 'dragon-aku-2',
    name: 'DRAGON AKU 2',
    power: '12 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-2-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 2',
    description: 'Wkład powietrzny akumulacyjny 12 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 8190, double: 8830, triple: 9560 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 450, 'recessed-30': 530, 'recessed-15-45': 560 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A+',
      glassSize: '655 x 471 mm',
      insertSize: '708 x 1129-1284 x 450 mm',
      fireplaceSize: '445 x 500 x 254 mm',
      maxLogLength: '490 mm',
      weight: '163 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 2',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 2 w konfiguracji:\n\nModel: DRAGON AKU 2\nMoc: 12 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-2-xl': {
    id: 'dragon-aku-2-xl',
    name: 'DRAGON AKU 2 XL',
    power: '12 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-2-xl-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 2 XL',
    description: 'Wkład powietrzny akumulacyjny 12 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 8670, double: 9370, triple: 10120 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 370, 'flush-30': 420, 'recessed-15': 490, 'recessed-30': 550, 'recessed-15-45': 600 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,3%',
      energyClass: 'A+',
      glassSize: '655 x 514 mm',
      insertSize: '708 x 1172-1327 x 450 mm',
      fireplaceSize: '488 x 500 x 254 mm',
      maxLogLength: '490 mm',
      weight: '155 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 2 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 2 XL w konfiguracji:\n\nModel: DRAGON AKU 2 XL\nMoc: 12 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-4-slim': {
    id: 'dragon-aku-4-slim',
    name: 'DRAGON AKU 4 SLIM',
    power: '14 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-slim-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 4 SLIM',
    description: 'Wkład powietrzny akumulacyjny 14 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 8730, double: 9470, triple: 10280 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 430, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '14 kW',
      efficiency: '78,0%',
      energyClass: 'A+',
      glassSize: '717 x 471 mm',
      insertSize: '790 x 1114-1269 x 474 mm',
      fireplaceSize: '438 x 596 x 285 mm',
      maxLogLength: '580 mm',
      weight: '177 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 4 SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 4 SLIM w konfiguracji:\n\nModel: DRAGON AKU 4 SLIM\nMoc: 14 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-4': {
    id: 'dragon-aku-4',
    name: 'DRAGON AKU 4',
    power: '16 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-4-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 4',
    description: 'Wkład powietrzny akumulacyjny 16 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 9100, double: 9850, triple: 10650 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 430, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A+',
      glassSize: '717 x 471 mm',
      insertSize: '736 x 1114-1269 x 574 mm',
      fireplaceSize: '438 x 564 x 370 mm',
      maxLogLength: '530 mm',
      weight: '183 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 4',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 4 w konfiguracji:\n\nModel: DRAGON AKU 4\nMoc: 16 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-6': {
    id: 'dragon-aku-6',
    name: 'DRAGON AKU 6',
    power: '12 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-6-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 6',
    description: 'Wkład powietrzny akumulacyjny 12 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 8890, double: 9630, triple: 10440 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 360, 'flush-30': 410, 'recessed-15': 470, 'recessed-30': 540, 'recessed-15-45': 580 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A+',
      glassSize: '754 x 381 mm',
      insertSize: '777 x 1020-1275 x 444 mm',
      fireplaceSize: '370 x 605 x 254 mm',
      maxLogLength: '600 mm',
      weight: '150 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 6',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 6 w konfiguracji:\n\nModel: DRAGON AKU 6\nMoc: 12 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-6-xl': {
    id: 'dragon-aku-6-xl',
    name: 'DRAGON AKU 6 XL',
    power: '12 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-6-xl-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 6 XL',
    description: 'Wkład powietrzny akumulacyjny 12 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 9420, double: 10280, triple: 11240 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 390, 'flush-30': 440, 'recessed-15': 500, 'recessed-30': 560, 'recessed-15-45': 630 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A+',
      glassSize: '754 x 454 mm',
      insertSize: '777 x 1193-1348 x 444 mm',
      fireplaceSize: '440 x 605 x 254 mm',
      maxLogLength: '600 mm',
      weight: '176 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 6 XL',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 6 XL w konfiguracji:\n\nModel: DRAGON AKU 6 XL\nMoc: 12 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-9': {
    id: 'dragon-aku-9',
    name: 'DRAGON AKU 9',
    power: '14 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-9-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 9',
    description: 'Wkład powietrzny akumulacyjny 14 kW',
    specialNote: 'Wariant otwierania dostępny tylko w wersji Standard. Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).',
    basePrices: {
      standard: { single: 11030, double: 11990, triple: 13170 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 420, 'flush-30': 500, 'recessed-15': 550, 'recessed-30': 640, 'recessed-15-45': 690 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      akuPlus: { none: 0, 'aku-plus': 860 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '12 kW',
      efficiency: '78,0%',
      energyClass: 'A+',
      glassSize: '754 x 604 mm',
      insertSize: '777 x 1343-1498 x 444 mm',
      fireplaceSize: '590 x 659 x 280 mm',
      maxLogLength: '650 mm',
      weight: '208 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      akuPlus: {
        none: 'Brak',
        'aku-plus': 'AKU+'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 9',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 9 w konfiguracji:\n\nModel: DRAGON AKU 9\nMoc: 14 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Cena bez modułów akumulacyjnych. Dostępny również w wersji AKU+ (dopłata 860 zł netto).\n\nPozdrawiam'
    }
  },
  'dragon-aku-8': {
    id: 'dragon-aku-8',
    name: 'DRAGON AKU 8',
    power: '11 kW',
    type: 'powietrzny-aku',
    glassType: 'prosta' as const,
    image: 'images/dragon-8-aku.jpg',
    emailSubject: 'Zapytanie - DRAGON AKU 8',
    description: 'Wkład powietrzny akumulacyjny 11 kW',
    specialNote: 'Wkład dostępny jedynie w wersji AKU. Do wkładu dołączany jest stelaż na moduły akumulacyjne.',
    basePrices: {
      standard: { single: 7660, double: 8240, triple: 8940 }
    },
    extraPrices: {
      ceramic: { 'refrabox-light': 0, 'cerabox-graphite': 0 },
      handle: { 'classic-black': 0, 'classic-silver': 0, 'design-black': 0, 'design-black-silver': 0 },
      bezel: {
        standard: { none: 0, 'flush-15': 300, 'flush-30': 350, 'recessed-15': 390, 'recessed-30': 440, 'recessed-15-45': 490 }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    specs: {
      power: '11,5 kW',
      efficiency: '75,0%',
      energyClass: 'A+',
      glassSize: '423 x 513 mm',
      insertSize: '449 x 1105-1187 x 500 mm',
      fireplaceSize: '495 x 382 x 360 mm',
      maxLogLength: '360 mm',
      weight: '126 kg'
    },
    
    labels: {
      variant: { 
        standard: 'Standard - otwieranie na bok'
      },
      glass: { 
        single: 'Pojedyncza x1', 
        double: 'Podwójna x2', 
        triple: 'Potrójna x3'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        none: 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)'
      },
      fusion: { 
        none: 'Brak',
        fusion: 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON AKU 8',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON AKU 8 w konfiguracji:\n\nModel: DRAGON AKU 8\nMoc: 11 kW\nKonfigurację: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nUwaga: Dostępny jedynie w wersji AKU z dołączanym stelażem na moduły akumulacyjne. Cena bez modułów akumulacyjnych.\n\nPozdrawiam'
    }
  }
}
